module.exports = __webpack_public_path__ + "static/media/arrorw1.3783638c.svg";